var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoL4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 121,
    viewBox: "0 0 221 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.568 43.5078V43.542C219.23 51.4047 215.026 58.4593 208.31 62.4092C194.125 70.6665 167.285 86.3187 143.457 100.25L121.214 113.27C113.087 118.017 103.998 120.411 94.8887 120.411C87.281 120.411 79.6522 118.746 72.5781 115.394L7.54688 77.9727H7.54785C3.76575 75.7865 1.9636 72.3417 1.13867 68.5996C0.310275 64.8415 0.478421 60.8321 0.608398 57.5723V14.8955L88.8428 68.125V68.126C93.4067 70.8998 99.1129 70.8997 103.677 68.126C130.27 51.9822 215.652 2.65765 216.518 2.16016L218.142 1.22656H218.119L218.764 0.854492L219.568 43.5078Z",
    stroke: "#434D91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoL4);
export default __webpack_public_path__ + "static/media/logo-l-4.f9b60779f06df0da6176cb8665d9f75a.svg";
export { ForwardRef as ReactComponent };